class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((e) => this.onSubmitHandler(e), 500);
    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));

    const wrapper = this.querySelector('#FacetsWrapperDesktop');
    if (wrapper) wrapper.addEventListener('keyup', onKeyUpEscape);

    const btnShow = this.querySelector('.facets__button-show');
    const closeBtn = this.querySelector('.facets__close');
    const wrapperEl = this.querySelector('.facets__wrapper');
    const collection = this.closest('.collection-wrapper');

    if (btnShow) {
      btnShow.onclick = () => {
        wrapperEl.classList.add('active');
        collection.querySelector('.facets-container').classList.add('active');
        collection.querySelector('.products-grid__overlay').classList.add('active');
        document.body.classList.add('overflow-hidden');
        wrapperEl.querySelectorAll('details, a, input, button').forEach((e) => e.removeAttribute('tabindex'));
      };
    }

    if (closeBtn) {
      closeBtn.onclick = () => {
        wrapperEl.classList.remove('active');
        collection.querySelector('.facets-container').classList.remove('active');
        collection.querySelector('.products-grid__overlay').classList.remove('active');
        document.body.classList.remove('overflow-hidden');
        wrapperEl.querySelectorAll('details, a, input, button').forEach((e) => e.setAttribute('tabindex', '-1'));
      };
    }

    window.addEventListener('keyup', (e) => {
      if (e.code.toUpperCase() === 'ESCAPE') {
        wrapperEl.classList.remove('active');
        collection.querySelector('.facets-container').classList.remove('active');
        collection.querySelector('.products-grid__overlay').classList.remove('active');
        document.body.classList.remove('overflow-hidden');
        wrapperEl.querySelectorAll('details, a, input, button').forEach((e) => e.setAttribute('tabindex', '-1'));
      }
    });

    document.addEventListener('click', (e) => {
      const disclosures = document.querySelectorAll('.facets__wrapper--horizontal .facets__disclosure');
      const activeDisclosure = e.target.closest('.facets__disclosure[open]');
      const united = document.querySelector('.facets__wrapper--horizontal_united');
      const currentUnited = e.target.closest('.facets__wrapper--horizontal_united');
      const loadingOverlay = e.target.closest('.loading-overlay');
      if (
        united &&
        united !== currentUnited &&
        !e.target.closest('.facets__reset') &&
        !btnShow.contains(e.target) &&
        !loadingOverlay
      ) {
        united.classList.remove('active');
        e.target.closest('.products-grid__overlay')?.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
      }
      if (!activeDisclosure) disclosures.forEach((e) => e.removeAttribute('open'));
    });
  }

  static calcMinHeight = () => {
    const top = document.querySelector('.facets__top');
    const sort = document.querySelector('.facets__sort-wrapper');
    const wrapper = document.querySelector('.collection-wrapper');
    if (top && sort && wrapper) {
      const height = Math.max(top.getBoundingClientRect().height, sort.getBoundingClientRect().height);
      wrapper.style.gridTemplateRows = `${height}px auto 1fr`;
    }
  };

  static setListeners() {
    window.addEventListener('popstate', (e) => {
      const params = e.state?.searchParams || FacetFiltersForm.searchParamsInitial;
      if (params !== FacetFiltersForm.searchParamsPrev) FacetFiltersForm.renderPage(params, null, false);
    });
  }

  static toggleActiveFacets(disabled = true) {
    document.querySelectorAll('.js-facet-remove').forEach((el) => el.classList.toggle('disabled', disabled));
  }

  static renderPage(searchParams, target, updateURL = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const count = document.getElementById('ProductCount');
    const countDesktop = document.getElementById('ProductCountDesktop');
    const resultsBtn = document.querySelector('.button--results');

    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (count) count.classList.add('loading');
    if (countDesktop) countDesktop.classList.add('loading');
    else document.querySelector('.loading-overlay').style.top = '0';
    if (resultsBtn) resultsBtn.classList.add('loading');

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const cached = (e) => e.url === url;
      FacetFiltersForm.filterData.some(cached)
        ? FacetFiltersForm.renderSectionFromCache(cached, target)
        : FacetFiltersForm.renderSectionFromFetch(url, target);
    });

    if (updateURL) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, target) {
    fetch(url)
      .then((r) => r.text())
      .then((html) => {
        FacetFiltersForm.filterData.push({ html, url });
        FacetFiltersForm.renderFilters(html, target);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(match, target) {
    const html = FacetFiltersForm.filterData.find(match).html;
    FacetFiltersForm.renderFilters(html, target);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;
    (document.querySelector('.js-load-more') || document.querySelector('.js-infinite-scroll')) && loadMore();
    colorSwatches();
  }

  static renderProductCount(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const countHTML = parsed.getElementById('ProductCount').innerHTML;
    const count = document.getElementById('ProductCount');
    const countDesktop = document.getElementById('ProductCountDesktop');
    const resultsBtn = document.querySelector('.button--results');

    count.innerHTML = countHTML;
    count.classList.remove('loading');
    if (resultsBtn) resultsBtn.classList.remove('loading');
    if (countDesktop) {
      countDesktop.innerHTML = countHTML;
      countDesktop.classList.remove('loading');
    }

    document
      .querySelectorAll('.facets__wrapper details, .facets__wrapper a, .facets__wrapper input, .facets__wrapper button')
      .forEach((e) => e.removeAttribute('tabindex'));
  }

  static renderFilters(html, target) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const filters = doc.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersPillsForm .js-filter');

    const match = (el) => {
      const t = target?.target?.closest('.js-filter');
      return t && el.dataset.index === t.dataset.index;
    };

    const toReplace = Array.from(filters).filter((el) => !match(el));
    const toUpdate = Array.from(filters).find(match);

    toReplace.forEach((el) => {
      const current = document.querySelector(`.js-filter[data-index="${el.dataset.index}"]`);
      current.innerHTML = el.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(doc);

    if (toUpdate) {
      const wrapper = target.target.closest('.js-filter');
      FacetFiltersForm.renderCounts(toUpdate, wrapper);
    }
  }

  static renderActiveFacets(doc) {
    ['.active-facets-desktop'].forEach((selector) => {
      const newContent = doc.querySelector(selector);
      if (newContent) {
        document.querySelector(selector).innerHTML = newContent.innerHTML;
        FacetFiltersForm.calcMinHeight();
      }
    });
    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderCounts(newEl, wrapper) {
    const newSelected = newEl.querySelector('.facets__selected');
    const currentSelected = wrapper.querySelector('.facets__selected');
    const newSummary = newEl.querySelector('.facets__summary');
    const currentSummary = wrapper.querySelector('.facets__summary');

    if (newSelected && currentSelected) currentSelected.outerHTML = newSelected.outerHTML;
    if (newSummary && currentSummary) currentSummary.outerHTML = newSummary.outerHTML;
  }

  static updateURLHash(params) {
    history.pushState({ searchParams: params }, '', `${window.location.pathname}${params ? '?' + params : ''}`);
  }

  static getSections() {
    return [{ section: document.getElementById('product-grid').dataset.id }];
  }

  createSearchParams(form) {
    return new URLSearchParams(new FormData(form)).toString();
  }

  onSubmitForm(params, target) {
    FacetFiltersForm.renderPage(params, target);
  }

  onSubmitHandler(e) {
    e.preventDefault();
    const forms = document.querySelectorAll('facet-filters-form form');
    if (e.srcElement.className === 'mobile-facets__checkbox') {
      const params = this.createSearchParams(e.target.closest('form'));
      this.onSubmitForm(params, e);
    } else {
      const paramsList = [];
      forms.forEach((f) => {
        if (['FacetSortForm', 'FacetFiltersForm', 'FacetSortDrawerForm'].includes(f.id)) {
          document.querySelectorAll('.no-js-list').forEach((n) => n.remove());
          paramsList.push(this.createSearchParams(f));
        }
      });
      this.onSubmitForm(paramsList.join('&'), e);
    }
  }

  onActiveFilterClick(e) {
    e.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const params = e.currentTarget.href.includes('?') ? e.currentTarget.href.split('?')[1] : '';
    FacetFiltersForm.renderPage(params);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);

customElements.define('facet-filters-form', FacetFiltersForm);

FacetFiltersForm.setListeners();
class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((e) => e.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
    this.controlSlider();
    this.controlInput();
  }
  onRangeChange(e) {
    this.adjustToValidValues(e.currentTarget);
    this.setMinAndMaxValues();
  }
  setMinAndMaxValues() {
    let e = this.querySelectorAll('input'),
      t = e[0],
      r = e[1];
    r.value && t.setAttribute('max', r.value);
    t.value && r.setAttribute('min', t.value);
    '' === t.value && r.setAttribute('min', 0);
    '' === r.value && t.setAttribute('max', r.getAttribute('max'));
  }
  adjustToValidValues(e) {
    let t = +e.value,
      r = +e.getAttribute('min'),
      a = +e.getAttribute('max');
    t < r && (e.value = r);
    a < t && (e.value = a);
  }
  fillSlider() {
    document.querySelectorAll('.facets__price .facets__range').forEach((e) => {
      let t = e.querySelectorAll('.field__range'),
        r = t[0],
        a = t[1],
        n = a.max - a.min,
        m = r.value - a.min;
      e.setAttribute('style', `--range-min:${(m / n) * 100}%;--range-max:${((a.value - a.min) / n) * 100}%`);
    });
  }
  controlSlider() {
    let priceRange = document.querySelectorAll('.facets__price .facets__range');
    let wrapper = document.querySelectorAll('.facets__price .facets__price-wrapper');
    priceRange.forEach((range, index) => {
      let r = range.querySelectorAll('.field__range'),
        a = r[0],
        n = r[1];
      let c = wrapper[index].querySelectorAll('.field__input')[0],
        s = wrapper[index].querySelectorAll('.field__input')[1];
      a.oninput = () => {
        let v = +a.value,
          u = +n.value;
        u < v ? ((a.value = u), (c.value = u)) : (c.value = v);
        this.fillSlider();
      };
      n.style.zIndex = +n.value <= 0 ? 2 : 0;
      n.oninput = () => {
        let v = +a.value,
          u = +n.value;
        v <= u ? ((n.value = u), (s.value = u)) : ((s.value = v), (n.value = v));
        n.style.zIndex = +n.value <= 0 ? 2 : 0;
        this.fillSlider();
      };
    });
  }
  controlInput() {
    let o = document.querySelectorAll('.facets__price .facets__range');
    document.querySelectorAll('.facets__price .facets__price-wrapper').forEach((e, i) => {
      let inputs = e.querySelectorAll('.field__input'),
        a = inputs[0],
        n = inputs[1];
      let c = o[i].querySelectorAll('.field__range')[0],
        s = o[i].querySelectorAll('.field__range')[1];
      a.oninput = () => {
        let v = parseInt(a.value, 10),
          u = parseInt(n.value, 10);
        u < v ? ((c.value = u), (a.value = u)) : (c.value = v);
        this.fillSlider();
      };
      n.oninput = () => {
        let v = parseInt(a.value, 10),
          u = parseInt(n.value, 10);
        v <= u ? ((s.value = u), (n.value = u)) : (n.value = v);
        this.fillSlider();
      };
    });
  }
}
customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    let e = this.querySelector('a');
    e.setAttribute('role', 'button');
    e.addEventListener('click', this.closeFilter.bind(this));
    e.addEventListener('keyup', (t) => {
      t.preventDefault();
      'SPACE' === t.code.toUpperCase() && this.closeFilter(t);
    });
  }
  closeFilter(e) {
    e.preventDefault();
    (this.closest('facet-filters-form') || document.querySelector('facet-filters-form')).onActiveFilterClick(e);
  }
}
customElements.define('facet-remove', FacetRemove);
